// @flow
// @flow-runtime warn
import { createContext } from 'react';

import { type RecipientsType } from './RecipientsTypes';
import { defaultRecipientsState } from './useRecipientsData';


type RecipientsContextType = [
  RecipientsType,
  boolean,
  () => Promise<boolean> | boolean
]

const defaultContext: RecipientsContextType = [
  defaultRecipientsState,
  true,
  () => false,
];

export default createContext<RecipientsContextType>(defaultContext);
